import{APP_ERROR,PIPELINE_ERROR}from"../constants/ActionTypes";import{main$}from"./main";/**
 * Gets triggered when an app error is received.
 * @type {Observable}
 */export var appError$=main$.filter(function(_ref){var action=_ref.action;return action.type===APP_ERROR;});/**
 * Gets triggered when an pipeline error is received.
 * @type {Observable}
 */export var pipelineError$=main$.filter(function(_ref2){var action=_ref2.action;return action.type===PIPELINE_ERROR;});